/* amethyst-units.js (01/10/26, demande Mathéo : « afficher les bonnes dimensions dans les bons pays, avec les bonnes unités,
   taille S / taille L avec les dimensions exactes à côté ») : boutiques bijoux Bennett & Cross, Marco Maveri et Lynore
   (Atlas a déjà son système dans snippets/atlas-product-sizeguide.liquid, mêmes règles : ne pas l'y installer).
   Réécrit SEULEMENT le texte affiché des options (boutons, listes, libellé sélectionné, panier). Les valeurs des variantes,
   les attributs, le panier, Google Shopping et CJ ne changent pas.
   - Pendentifs « 25mm W x 45mm H » : S / M / L selon la taille dans la fiche + dimensions (mm, pouces aux US).
   - Longueurs de chaîne / bracelet (cm ou ") : unité du pays seule, comme Atlas (pouces US, CA, GB ; cm ailleurs).
   - Tailles de bague US : lettres UK (GB, IE, AU, NZ, ZA), tour de doigt EU ailleurs, US inchangé (US, CA).
   13/10/26 (GO Mathéo, règle vérifiée chez les bijoutiers de chaque pays) : 4 modes.
   « us » = US, PR, LR, MM : pouces seuls, bagues US. « dual » = CA, GB : cm PUIS pouces entre parenthèses « 46 cm (18") »,
   « 5 mm (0.20") » ; bagues US (CA) ou lettres UK (GB). « ukm » = IE, AU, NZ : cm seuls, bagues en lettres UK.
   « eu » = tous les autres : cm seuls, bagues EU (tour de doigt en mm). */
(function () {
  try {
    var C = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
    var MODE = ['US', 'PR', 'LR', 'MM'].indexOf(C) > -1 ? 'us' : (['CA', 'GB'].indexOf(C) > -1 ? 'dual' : (['IE', 'AU', 'NZ'].indexOf(C) > -1 ? 'ukm' : 'eu'));
    var LEN_IMP = MODE === 'us', DUAL = MODE === 'dual';
    var DIM_IMP = MODE === 'us';
    var RING = (MODE === 'us' || C === 'CA' || C === '') ? 'US' : ((C === 'GB' || MODE === 'ukm') ? 'UK' : 'EU');
    var LANG = (document.documentElement.lang || 'en').split('-')[0];
    var NF = new Intl.NumberFormat(LANG, { maximumFractionDigits: 1 });
    var f1 = function (n) { return NF.format(Math.round(n * 10) / 10); };
    var fCm = function (n) { return NF.format(n >= 30 ? Math.round(n) : Math.round(n * 2) / 2); };
    var fIn = function (n) { var r = Math.round(n); return NF.format(n * 2.54 >= 30 || Math.abs(n - r) < 0.12 ? r : Math.round(n * 10) / 10); }; // pouces tirés de cm (CA / GB) : 45 cm -> 18" (comme les guides), 18 cm -> 7", 20 cm -> 7.9"
    var reDualDone = /cm\s*\(\s*\d[\d.,]*(?:\s*[-–×x]\s*\d[\d.,]*)?\s*(?:"|″|”|in)/i; // déjà au format « 46 cm (18") »
    var RT = { 4: ['H½', 47], 4.5: ['I½', 48], 5: ['J½', 49], 5.5: ['K½', 51], 6: ['L½', 52], 6.5: ['M½', 53], 7: ['N½', 54], 7.5: ['O½', 56], 8: ['P½', 57], 8.5: ['Q½', 58], 9: ['R½', 60], 9.5: ['S½', 61], 10: ['T½', 62], 10.5: ['U½', 63], 11: ['V½', 65], 11.5: ['W½', 66], 12: ['X½', 67], 12.5: ['Y½', 68], 13: ['Z+1', 70], 13.5: ['Z+2', 71], 14: ['Z+3', 72], 14.5: ['Z+3½', 74], 15: ['Z+4', 75], 15.5: ['Z+5', 76], 16: ['Z+6', 77] }; // 01/10 : lettres UK standard (US 7 = N½, 54,4 mm), alignées sur le guide des tailles Bennett
    var LETTERS = { 2: ['S', 'L'], 3: ['S', 'M', 'L'], 4: ['S', 'M', 'L', 'XL'], 5: ['XS', 'S', 'M', 'L', 'XL'] };
    var num = function (s) { return parseFloat(String(s).replace(',', '.')); };

    var reDim = /^(\d+(?:[.,]\d+)?)\s*mm\s*W\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*mm\s*H$/i;
    var reLen = /^(.*?)(\d+(?:[.,]\d+)?)\s*(cm|"|″|”|''|in\.?|inch(?:es)?)$/i;
    var reRingUS = /^US\s*(\d{1,2}(?:[.,]5)?)$/i;

    var SW = { en: { XS: 'X-Small', S: 'Small', M: 'Medium', L: 'Large', XL: 'X-Large', t: '{h} tall' }, fr: { XS: 'Très petit', S: 'Petit', M: 'Moyen', L: 'Grand', XL: 'Très grand', t: '{h} de haut' },
      de: { XS: 'Sehr klein', S: 'Klein', M: 'Mittel', L: 'Groß', XL: 'Sehr groß', t: '{h} hoch' }, es: { XS: 'Muy pequeño', S: 'Pequeño', M: 'Mediano', L: 'Grande', XL: 'Muy grande', t: '{h} de alto' },
      it: { XS: 'Molto piccolo', S: 'Piccolo', M: 'Medio', L: 'Grande', XL: 'Molto grande', t: '{h} di altezza' }, nl: { XS: 'Extra klein', S: 'Klein', M: 'Middel', L: 'Groot', XL: 'Extra groot', t: '{h} hoog' },
      pt: { XS: 'Muito pequeno', S: 'Pequeno', M: 'Médio', L: 'Grande', XL: 'Muito grande', t: '{h} de altura' } };
    var SWL = SW[LANG] || SW.en;
    function word(l) { return SWL[l] || l; }
    function tall(v) { var m = reDim.exec(v); if (!m) return dims(v); var h = num(m[2]); return SWL.t.replace('{h}', DIM_IMP ? f1(h / 25.4) + '"' : (DUAL ? f1(h / 10) + ' cm (' + f1(h / 25.4) + '")' : f1(h / 10) + ' cm')); }
    function dims(v) { var m = reDim.exec(v); if (!m) return null; var w = num(m[1]), h = num(m[2]); return DIM_IMP ? f1(w / 25.4) + ' × ' + f1(h / 25.4) + ' in' : f1(w) + ' × ' + f1(h) + ' mm' + (DUAL ? ' (' + f1(w / 25.4) + ' × ' + f1(h / 25.4) + '")' : ''); }
    // chaque longueur du libellé passe dans l'unité du pays : « Necklace 18" », « 2mm / 45cm », « 15.75" + 2" ext », « 2.2" inner diameter »
    // 01/10/26 : plages et dimensions « 41-50cm », « 16 – 20" », « 41 à 50 cm », « 16 to 20 in », « 2 x 3 cm » : les DEUX bornes
    // sont converties (avant : seule la 2e, d'où « 41-19,7" »). Sortie toujours dans l'unité du pays : jamais de double conversion.
    var U = '(cm\\b|"|″|”|inch(?:es)?\\b)';
    var reLenAll = new RegExp('(\\d+(?:[.,]\\d+)?)(?:\\s*' + U + '?(\\s*[-–—]\\s*|\\s+(?:to|à)\\s+|\\s*[x×]\\s*)(\\d+(?:[.,]\\d+)?))?\\s*' + U, 'gi');
    function length(v) {
      if (v.length > 40) return null;
      // texte qui porte déjà les deux unités : « 46 cm (18") » / « 18" (46 cm) » -> une seule unité, ou cm (pouces) pour CA / GB
      var pre = v.replace(/(\d+(?:[.,]\d+)?)\s*cm\s*\(\s*(\d+(?:[.,]\d+)?)\s*(?:"|″|”|in\.?)\s*\)/gi, function (a, c, i) { return LEN_IMP ? i + '"' : (DUAL ? a : c + ' cm'); })
        .replace(/(\d+(?:[.,]\d+)?)\s*(?:"|″|”|in\.?)\s*\(\s*(\d+(?:[.,]\d+)?)\s*cm\s*\)/gi, function (a, i, c) { return LEN_IMP ? i + '"' : (DUAL ? c + ' cm (' + i + '")' : c + ' cm'); });
      if (pre !== v) return pre;
      if (DUAL && reDualDone.test(v)) return null; // déjà converti
      var out = v.replace(reLenAll, function (all, na, ua, sep, nb, u) {
        var parts = nb ? [[num(na), ua || u], [num(nb), u]] : [[num(na), u]];
        var todo = DUAL; // CA / GB : toujours « cm (pouces) »
        for (var i = 0; i < parts.length; i++) {
          var isCm = /cm/i.test(parts[i][1]);
          if (!isCm && parts[i][0] > 60) return all; // ce ne sont pas des pouces
          parts[i][2] = isCm;
          if (isCm === LEN_IMP) todo = true;
        }
        if (!todo) return all; // déjà dans l'unité du pays
        var s = '';
        if (nb) s = /[x×]/i.test(sep) ? ' × ' : (/[-–—]/.test(sep) ? '-' : sep);
        if (DUAL) {
          var cmv = parts.map(function (p) { return fCm(p[2] ? p[0] : p[0] * 2.54); });
          var inv = parts.map(function (p) { return p[2] ? fIn(p[0] / 2.54) : f1(p[0]); });
          return cmv.join(s) + ' cm (' + inv.join(s) + '")';
        }
        var conv = parts.map(function (p) {
          if (LEN_IMP) return f1(p[2] ? p[0] / 2.54 : p[0]);
          return fCm(p[2] ? p[0] : p[0] * 2.54);
        });
        return conv.join(s) + (LEN_IMP ? '"' : ' cm');
      });
      return out !== v ? out : null;
    }
    function composite() { return null; }
    function ring(n) { // quarts de taille (Lynore 4.75, 7.25…) : lettre UK de la demi-taille la plus proche, EU = tour de doigt calculé
      if (RING === 'US' || !(n >= 3 && n <= 16)) return null;
      var r = RT[Math.round(n * 2) / 2]; if (!r) return null;
      var eu = Math.round(Math.PI * (11.63 + 0.8128 * n));
      return (RING === 'UK' ? r[0] : String(eu)) + ' (US ' + String(n).replace('.', LANG === 'en' ? '.' : ',') + ')';
    }
    function generic(v) { // sans contexte produit : motifs sans ambiguïté seulement
      var d = dims(v); if (d) return d;
      var m = reRingUS.exec(v); if (m) return ring(num(m[1]));
      return length(v) || composite(v);
    }

    var MAP = {}; // valeur exacte -> libellé affiché (fiche en cours)
    function buildFromProduct(p) {
      var noRing = /earring|stud|hoop|boucle|pendant|necklace|bracelet/i.test((p.type || '') + ' ' + (p.title || '')); // fausse option « Ring Size » sur des boucles d'oreilles
      (p.options || []).forEach(function (o) {
        var name = String(o.name || ''), vals = o.values || [];
        var isDim = vals.length > 0 && vals.every(function (v) { return reDim.test(v); });
        if (isDim) {
          var area = vals.map(function (v) { var m = reDim.exec(v); return [v, num(m[1]) * num(m[2])]; }).sort(function (a, b) { return a[1] - b[1]; });
          var L = LETTERS[vals.length];
          // 01/10/26 (Mathéo : « le plus simple pour les clients ») : mot + hauteur seule, « Small · 1.8" tall » / « Petit · 4,5 cm de haut »
          area.forEach(function (x, i) { MAP[x[0]] = (L ? word(L[i]) + ' · ' : '') + tall(x[0]); });
          return;
        }
        // 13/10/26 : largeurs « 4mm » (toutes les valeurs en mm) : pouces US / PR / LR / MM « 0.16" », « 4 mm (0.16") » CA / GB, inchangé ailleurs
        var isWid = vals.length > 0 && vals.every(function (v) { return /^\d+(?:[.,]\d+)?\s?mm$/i.test(String(v).trim()); });
        if (isWid) {
          // 16/10/26 (Mathéo, comme Atlas le 14/10) : largeurs en mm dans TOUS les pays (« 4 mm »), plus de pouces
          vals.forEach(function (v) { MAP[v] = NF.format(num(v)) + ' mm'; });
          return;
        }
        var ringOpt = /ring/i.test(name) || vals.every(function (v) { return reRingUS.test(v); });
        vals.forEach(function (v) {
          var r = null;
          if (ringOpt && !noRing) { var m = reRingUS.exec(v) || /^(\d{1,2}(?:[.,]5)?)$/.exec(v); if (m) r = ring(num(m[1])); }
          if (!r) r = length(v) || composite(v);
          if (r && r !== v) MAP[v] = r;
        });
      });
    }

    var OUT = new Set();
    var SKIP = /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|CODE|PRE)$/;
    function scope(el) { // pas dans les articles, descriptions, avis
      var a = el.closest('article, .rte, [class*="description"], [class*="review"], [class*="blog"], [contenteditable]');
      return !a || a === document.documentElement || a === document.body; // classes posées sur <html>/<body> (ex. Marco « mm-no-reviews ») ignorées
    }
    function apply(root) {
      var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null), n, todo = [];
      while ((n = w.nextNode())) {
        var t = n.nodeValue; if (!t || t.length > 80) continue;
        var s = t.trim(); if (!s || OUT.has(s)) continue;
        var p = n.parentElement; if (!p || SKIP.test(p.tagName)) continue;
        var r = MAP[s];
        if (!r && /\d/.test(s) && p.closest('[class*="cart"], [id*="cart"], [class*="drawer"], .bcp__form, .bcp4-dl dd, .bcp__specs dd, form[action*="/cart/add"], variant-picker, [class*="variant-option"], fieldset')) r = generic(s);
        if (r && r !== s && scope(p)) todo.push([n, t.replace(s, r), r]);
      }
      todo.forEach(function (x) { OUT.add(x[2]); x[0].nodeValue = x[1]; });
    }

    var pend = false;
    function schedule() { if (pend) return; pend = true; setTimeout(function () { pend = false; try { apply(); } catch (e) {} }, 60); }
    function start() {
      apply();
      new MutationObserver(function (ms) { /* FLUIDITE 2026-11-03 tick : le compte à rebours ne relance pas la conversion de toute la page */ for (var i = 0; i < ms.length; i++) { var t = ms[i].target, e = t.nodeType === 1 ? t : t.parentElement; if (!e || !e.closest || !e.closest('[data-mm-ebf-cd],[data-mmd-countdown]')) { schedule(); return; } } }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    var isPdp = /\/products\/[^/?#]+/.test(location.pathname);
    if (isPdp) {
      var url = location.pathname.replace(/\/$/, '').replace(/(\/products\/[^/]+).*$/, '$1') + '.js';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (p) { try { buildFromProduct(p); } catch (e) {} }).catch(function () {})
        .then(function () { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start(); });
    } else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.AMT_UNITS = { country: C, mode: MODE, ring: RING, lenImperial: LEN_IMP, dual: DUAL, map: MAP };
  } catch (e) {}
})();
